import Navigation from "../components/navigation";
import Footer from "../components/footer";
import HeadingTitle from "../pkg/components/heading-title";
import { companyName, navigation } from "../config/constants";
import Header from "../components/header";
import Main from "../pkg/components/main";
import LeadParagraph from "../pkg/components/lead-paragraph";

function Automata() {
	return (
		<>
			<Navigation companyName={companyName} navigation={navigation} />

			<Main>
				<Header>Automata</Header>

				<HeadingTitle>Agentic Engineers</HeadingTitle>

				<LeadParagraph>
					Development is no longer bottlenecked by bandwidth. AI agents convert ontology into executable software—code that reflects the 
                    business as it is, not as it was. Graph-driven, context-aware, continuously improving. These agents write, test, and adapt while 
                    humans steer. The result: systems that are aligned from spec to syntax. The distance between idea and implementation collapses.
				</LeadParagraph>
			</Main>

			<Footer />
		</>
	);
}

export default Automata;
